var $8d6b4a0f50df4fc5$exports = {};
$8d6b4a0f50df4fc5$exports = {
    "collectionLabel": `Sugestii`
};


export {$8d6b4a0f50df4fc5$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
